import { useEffect, useState } from 'react'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import { PageErrorBoundary } from './components/ErrorBoundary'
import { AuthProvider } from './context/AuthContext'
import { ThemeProvider, type Theme } from './context/ThemeContext'
import { ToastProvider } from './context/ToastContext'
import { PublicConfigProvider } from './context/PublicConfigContext'
import { AppGate, RequireAdmin, RequireAuth } from './components/guards'
import { Layout } from './components/Layout'
import { LoginPage } from './pages/Login'
import { SetupWizardPage } from './pages/SetupWizard'
import { HomePage } from './pages/Home'
import { RoomPage } from './pages/Room'
import { NotFoundPage } from './pages/NotFound'
import { AdminLayout } from './pages/admin/AdminLayout'
import { UsersPage } from './pages/admin/UsersPage'
import { SettingsPage } from './pages/admin/SettingsPage'
import { SystemPage } from './pages/admin/SystemPage'
import { publicApi } from './api'

export function App() {
  const [defaultTheme, setDefaultTheme] = useState<Theme>('dark')

  useEffect(() => {
    void publicApi.config().then((cfg) => {
      setDefaultTheme(cfg.defaultTheme)
    }).catch(() => {})
  }, [])

  return (
    <BrowserRouter>
      <ThemeProvider defaultTheme={defaultTheme}>
        <ToastProvider>
          <AuthProvider>
            <PublicConfigProvider>
              <PageErrorBoundary>
                <AppGate>
                  <Routes>
                    <Route path="/setup" element={<SetupWizardPage />} />
                    <Route path="/login" element={<LoginPage />} />
                    <Route
                      element={
                        <RequireAuth>
                          <Layout />
                        </RequireAuth>
                      }
                    >
                      <Route path="/" element={<HomePage />} />
                      <Route path="/rooms/:slug" element={<RoomPage />} />
                      <Route
                        path="/admin"
                        element={
                          <RequireAdmin>
                            <AdminLayout />
                          </RequireAdmin>
                        }
                      >
                        <Route index element={<UsersPage />} />
                        <Route path="settings" element={<SettingsPage />} />
                        <Route path="system" element={<SystemPage />} />
                      </Route>
                      <Route path="*" element={<NotFoundPage />} />
                    </Route>
                    <Route path="*" element={<Navigate to="/" replace />} />
                  </Routes>
                </AppGate>
              </PageErrorBoundary>
            </PublicConfigProvider>
          </AuthProvider>
        </ToastProvider>
      </ThemeProvider>
    </BrowserRouter>
  )
}
